module.exports = __webpack_public_path__ + "img/request-accept.0d969707.svg";